
import { css } from 'lit';
export default css`
:host {
    display: block;
}

.image-style-align-left, image-style-align-left {
    float: left;
}

.image-style-align-left, image-style-align-left {
    margin-bottom: 2rem;
}

.image-style-align-left, image-style-align-left {
    margin-right: 2rem;
}

.image-style-align-right, image-style-align-right {
    float: right;
}

.image-style-align-right, image-style-align-right {
    margin-bottom: 2rem;
}

.image-style-align-right, image-style-align-right {
    margin-left: 2rem;
}

.image-style-align-center, image-style-align-center {
    margin-left: auto;
    margin-right: auto;
}

.image-style-align-center, image-style-align-center {
    margin-top: 2rem;
    margin-bottom: 2rem;
}

.image-style-size-full, image-style-size-full {
    width: 100%;
}

.image-style-size-cta-card, image-style-size-cta-card {
    height: 261px;
    -o-object-fit: cover;
       object-fit: cover;
  }

@media (min-width: 768px) {

.image-style-size-cta-card, image-style-size-cta-card {
      height: 170px
  }
    }

@media (min-width: 768px) {

.image-style-size-cta-card, image-style-size-cta-card {
      height: 241px
  }
    }

.image_resized img, image_resized img {
    width: 100%;
}

.image_full-height, image_full-height {
    height: auto;
  }
`;